module.exports = __webpack_public_path__ + "static/media/header-logo.f95f3026.png";